






































import { Vue, Component, Lifecycle } from "av-ts";
import { IDate, IEvent, IEventLookup, ILocalisedEvent, ITime } from "../../interfaces/models";

import EventService from "../../services/EventService";
import Fetcher from "../../services/Fetcher";

import OverviewDescription from "../util/OverviewDescription.vue";
import Timeline from "../util/Timeline.vue";

@Component({
    components: {
        OverviewDescription,
        Timeline
    }
})
export default class Schedule extends Vue {

    pEventLookup: IEventLookup = {};

    updateEvents(newEvents: IEvent[]) {
        this.pEventLookup = this.createEventLookup(newEvents);
    };

    createEventLookup(events: IEvent[]): IEventLookup {
        let eventLookup: IEventLookup = {};

        events.map((event: IEvent) => {
            const eventDate: Date = new Date(event.time);
            const localisedEvent = this.localiseEvent(eventDate, event);
            this.addlocalisedEvent(eventLookup, localisedEvent);
        });

        this.sortEvents(eventLookup);
        return eventLookup;
    }

    nowUTC(): IDate {
        const now = new Date();
        const year = now.getUTCFullYear();
        const month = now.getUTCMonth();
        const date = now.getUTCDate();
        const day = now.getUTCDay();
        const hour = now.getUTCHours();
        const minute = now.getUTCMinutes();
        const second = 0;
        const millisecond = 0;

        const utcDate = {
            year,
            month,
            date,
            day,
            hour,
            minute,
            second,
            millisecond
        };

        return utcDate;
    };

    addDays(date: string, days: number): Date {
        // From: https://stackoverflow.com/questions/563406/add-days-to-javascript-date
        let result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    localisedEventDate(now: Date, days: number, time: ITime): Date {
        let eventDate: Date = this.addDays(now.toUTCString(), days);
        eventDate.setHours(time.start.hour);
        eventDate.setMinutes(0);
        eventDate.setSeconds(0);
        eventDate.setMilliseconds(0);
        return eventDate;
    }

    localiseEvent(date: Date, event: IEvent) {
        const localisedEventDate: ILocalisedEvent = {
            id: event.id,
            date: date.toString(),
            user: event.user,
            recommendedRole: event.recommendedRole,
            location: event.location
        };
        return localisedEventDate;
    }

    addlocalisedEvent(eventLookup: IEventLookup, localisedEvent: ILocalisedEvent) {
        let date = new Date(localisedEvent.date).toDateString();
        if (eventLookup) {
            if (eventLookup[date] === undefined) {
                eventLookup[date] = [localisedEvent];
            } else {
                eventLookup[date].push(localisedEvent);
            }
            return eventLookup;
        } else {
            let newLookup: IEventLookup = {};
            newLookup[date] = [localisedEvent];
            return newLookup;
        }
    }

    sortEvents(eventLookup: IEventLookup) {
        Object.keys(eventLookup).map(key => {
            let event = eventLookup[key];
            event.sort((a: ILocalisedEvent, b: ILocalisedEvent) => {
                return new Date(a.date).getTime() - new Date(b.date).getTime();
            });
        });
    }

    @Lifecycle
    created() {
        Fetcher.get(EventService.getWeekEvents).on(this.updateEvents);
    }

    @Lifecycle
    destroyed() {
        Fetcher.get(EventService.getWeekEvents).off(this.updateEvents);
    }

    cancelEvent(id: number) {
        EventService.cancelEvent(id)
            .then(_ => EventService.getWeekEvents())
            .then(x => this.updateEvents(x));
    }

    get eventLookup() {
        return this.pEventLookup;
    }

    get sortedDates() {
        let dates: string[] = Object.keys(this.pEventLookup);
        let sortedDates: Date[] = [];
        if (dates.length > 0) {
            dates.map(date => sortedDates.push(new Date(date)));
            sortedDates.sort((a, b) => a.getTime() - b.getTime());
        }

        return sortedDates;
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/peers/Schedule.vue